<ngb-carousel *ngIf="images">
    <ng-template ngbSlide>
      <div class="picsum-img-wrapper">
        <img class="img-fluid" [src]="images[0]" [height]="x" alt="Random first slide">
      </div>
    </ng-template>
    <ng-template ngbSlide>
      <div class="picsum-img-wrapper">
        <img class="img-fluid" [src]="images[1]" [height]="x" alt="Random second slide">
      </div>
    </ng-template>
    <ng-template ngbSlide>
      <div class="picsum-img-wrapper">
        <img class="img-fluid" [src]="images[2]" [height]="x" alt="Random third slide">
      </div>
    </ng-template>
    <ng-template ngbSlide>
      <div class="picsum-img-wrapper">
        <img class="img-fluid" [src]="images[3]" [height]="x" alt="Random third slide">
      </div>
    </ng-template>
  </ngb-carousel>